import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../common/sharedmodule';

@Component({
  selector: 'app-authentication-layout',
  templateUrl: './authentication-layout.component.html',
  styleUrl: './authentication-layout.component.scss'
})
export class AuthenticationLayoutComponent {

}
